import { css } from "lit"

export const RELATIVE = css`
  .relative {
    position: relative;
  }
`
export const FLEX = css`
  .flex {
    display: flex;
  }
  .flex-col {
    flex-direction: column;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .align-center {
    align-items: center;
  }
  .gap-0_5 {
    gap: 0.5rem;
  }
  .gap-1 {
    gap: 1rem;
  }
`

export const IS_HIDDEN = css`
  .is-hidden {
    display: none;
  }
`

export const FULL_WIDTH = css`
  .full-width {
    width: 100%;
  }
`
